import { provinceOrStateCodeFromString, provinceOrStateCodeFromName } from './province_or_state';

/**
 * Checks if a listing is from Quebec based on its province field.
 * 
 * This utility handles various formats of Quebec province identifiers:
 * - Province codes: 'qc', 'QC'
 * - Full names: 'Quebec', 'Québec'
 * 
 * @param province The province string from the listing
 * @returns true if the listing is from Quebec, false otherwise
 * 
 * @example
 * isQuebecListing('qc') // true
 * isQuebecListing('QC') // true
 * isQuebecListing('Quebec') // true
 * isQuebecListing('on') // false
 * isQuebecListing('Ontario') // false
 */
export function isQuebecListing(province: string | null | undefined): boolean {
  if (!province) {
    return false;
  }

  // Try as province code first (e.g., 'qc', 'QC')
  const normalizedCode = provinceOrStateCodeFromString(province);
  if (normalizedCode === 'qc') {
    return true;
  }

  // Try as province name (e.g., 'Quebec', 'Québec')
  const codeFromName = provinceOrStateCodeFromName(province);
  return codeFromName === 'qc';
}

